import React, { Component } from 'react';
import iconVisa from 'images/icons/visa.svg'
import iconLoading from 'images/icons/loading.svg'
import iconMastercard from 'images/icons/mastercard.svg'
import iconAmex from 'images/icons/amex.svg'
import Very from '../../../helpers/request_wrapper'

class Step2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    }
  }

  charge = () => {
    this.setState({ loading: true });
    Very.post(`/subscriptions`, { plan_id: this.props.plan_id }).then(res => {
      window.location.replace(`payment_succeeded`)
    }, error => {
      console.log(error)
    })
  };

  render() {
    const { customer, package_id, amount } = this.props;
    const { loading } = this.state;

    return (
      <React.Fragment>
        <h2 className="center title mb-30">Checkout</h2>
        {!loading &&
          <div className="mx-auto" style={{ maxWidth: '390px' }}>
            {customer.card_type === 'Visa' &&
            <div className="bg-bay-of-many mb-10 p-20 pt-50 rounded-6">
              <div className="flex flex-justify mb-50 px-20 sm-block">
                <img alt="" className="block sm-mb3" src={iconVisa} />

                <p className="fs-22 semi-bold text-white">**** **** **** {customer.last4}</p>
              </div>

              <a
                className="btn btn--primary btn--primary-bg-white-o-10 col-12"
                onClick={this.charge}
              >
                Pay - {amount/100}$
              </a>
            </div>}

            {customer.card_type === 'MasterCard' &&
            <div className="bg-black mb-10 p-20 pt-50 rounded-6">
              <div className="flex flex-justify mb-50 px-20 sm-block">
                <img alt="" className="block sm-mb3" src={iconMastercard} />

                <p className="fs-22 semi-bold text-white">**** **** **** {customer.last4}</p>
              </div>

              <a
                className="btn btn--primary btn--primary-bg-white-o-10 col-12"
                onClick={this.charge}
              >
                Pay - {amount/100}$
              </a>
            </div>}

            {customer.card_type === 'American Express' &&
            <div className="bg-science-blue mb-10 p-20 pt-50 rounded-6">
              <div className="flex flex-justify mb-50 px-20 sm-block">
                <img alt="" className="block sm-mb3" src={iconAmex} />

                <p className="fs-22 semi-bold text-white">**** **** **** {customer.last4}</p>
              </div>

              <a
                className="btn btn--primary btn--primary-bg-white-o-10 col-12"
                onClick={this.charge}
              >
                Pay - {amount/100}$
              </a>
            </div>}

            <div className="mb-10">
              <a
                className="btn btn--primary btn--primary-wild-sand btn--fs-12 btn--lh-28 col-12 mb-20 mx-auto"
                onClick={() => this.props.setStep(1)}
                style={{ width: '160px' }}
              >
                Use different card
              </a>
            </div>
          </div>
        }

        {loading &&
          <div className="flex flex-justify-center">
            <img alt="" className="block" src={iconLoading} />
          </div>
        }
      </React.Fragment>
    )
  }
}

export default Step2
